import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface GenerateIFRSExamIdResponse {
  id: string;
  title: string | null;
  status: string;
  duration: string | null;
  lectureId: string | null;
  chapterId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GenerateIFRSExamIdAPIResponse {
  message: string;
  data: GenerateIFRSExamIdResponse;
}

type GenerateIFRSExamIdAPIResult = {
  statusCode?: number;
  error?: ApiError | null;
  data?: GenerateIFRSExamIdAPIResponse;
};

export const GenerateIFRSExamId = async (): Promise<GenerateIFRSExamIdAPIResult> => {
  try {
    const response = await axios.post(`/ifrs/generate-id`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};


